import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
   Grid,
   GridItem,
   FormControl,
   Input,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   Checkbox,
   Textarea,
   Text,
} from '@chakra-ui/react';
import { Switch } from '@chakra-ui/react';
import { Tooltip } from '@chakra-ui/react';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody, usePopoverContext } from '@chakra-ui/react';
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import InputField from 'components/ui/InputField';
import '../../../theme/theme';
import editIcon from 'assets/img/nfts/edit.svg';
import editIcon2 from 'assets/img/nfts/edit.svg';
import about from 'assets/img/nfts/about.svg';
import { getDaybook, getDaybookForPayments } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';
import { useDispatch, useSelector } from 'react-redux';
import { getAccount, getAccountForCashBank } from '../../../redux/actions/account';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
   addVoucher,
   checkLastDocNumberVoucher,
   getBankVoucher,
   lastVoucherDetails,
   pendingVoucherDetails,
} from '../../../redux/actions/voucher';
import { toast } from 'react-toastify';
import { DAYBOOK_TYPE } from 'constants';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { getGLGroupsAllDropdown } from '../../../redux/actions/glGroup';
import { useUser, useGlobal } from 'contexts';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import Swal from 'sweetalert2';
import TextareaField from 'components/ui/TextareaField';

const PaymentcaseForm = ({
   isOpen,
   onClose,
   handleSave,
   isEditMode,
   selectedOption,
   receivedAmount,
   setReceivedAmount,
   checkedItems,
   setCheckedItems,
   editingValues,
   userData,
   errors,
   isBankPageTrue,
   setEditingValues,
   selectedAccount,
   setSelectedAccount,
   handleClearData,
   totalPendingAccount,
   setTotalPendingAccount,
   validationSchema,
   setErrors,
   handleSelect,
   handleInputChange,
   daybookTypeData,
   formData,
   setFormData,
   transactionType,
   currentPage,
   limit,
   searchQuery,
   sorting,
   pagination,
   handelformchange,
   fetchBankVoucherData,
}) => {
   const [currentRow, setCurrentRow] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);
   const dispatch = useDispatch();
   const txnDateRef = useRef(null);
   const daybookRef = useRef(null);
   const accountRef = useRef(null);
   const receivedAmtRef = useRef(null);
   const notesRef = useRef(null);
   const createRef = useRef(null);
   const cancelRef = useRef(null);
   const chequeNoRef = useRef(null);
   const chequeDateRef = useRef(null);
   const [focusedInput, setFocusedInput] = useState('');
   const [localDocNumber, setLocalDocNumber] = useState(1);
   const lastVoucherData = useSelector((state) => state.voucher?.lastVoucher || null);
   const pendingVoucher = useSelector((state) => state.voucher?.pendingVoucher || []);
   const account = useSelector((state) => state?.account?.listForCashBank || []);
   const glGroup = useSelector((state) => state?.glGroup?.list || []);
   const singleVoucher = useSelector((state) => state.voucher?.single || null);
   const [isTransaction, setIsTransaction] = useState(true);
   const location = useLocation();
   const [searchParams] = useSearchParams();
   const isBankPage = location.pathname.includes('/bank');
   const textColor = useColorModeValue('gray.800', 'white');
   const boxBgColor = useColorModeValue('gray.200', '#222831');
   const { user } = useUser();
   const companyId = user?.loginhistory?.companyId;
   const daybookbalance = daybookTypeData.find((item) => item.id === formData?.daybookId)?.bal ?? null;
   let accountAmt;
   const handleFocus = (id) => {
      setFocusedInput(id);
   };
   const handleBlur = () => {
      setFocusedInput('');
   };
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;

   const filteredAccountData = useMemo(() => {
      if (!formData.daybookId || !daybookTypeData || !account) {
         return account || [];
      }

      // Find the selected daybook
      const selectedDaybook = daybookTypeData.find((daybook) => daybook.id === formData.daybookId);

      if (!selectedDaybook || !selectedDaybook.accountId) {
         return account || [];
      }

      // Filter out the account that matches the daybook's accountId
      return account.filter((account) => account.id !== selectedDaybook.accountId);
   }, [formData.daybookId, daybookTypeData, account]);

   useEffect(() => {
      if (formData.daybookId && selectedAccount && daybookTypeData) {
         const selectedDaybook = daybookTypeData.find((daybook) => daybook.id === formData.daybookId);

         // If the currently selected account is the same as the daybook's account, clear it
         if (selectedDaybook && selectedDaybook.accountId === selectedAccount) {
            setSelectedAccount(null);
            setFormData((prev) => ({
               ...prev,
               accountId: null,
            }));
         }
      }
   }, [formData.daybookId, selectedAccount, daybookTypeData]);

   const handleAccountSelect = async (selected) => {
      if (selected) {
         // Update formData with the selected account ID
         setFormData({
            ...formData,
            accountId: selected, // Assuming the account ID is in the 'id' property
            // docNumber: localDocNumber,
         });

         // If transactions should be loaded
         if (isTransaction && !isNaN(selected) && user && user?.loginhistory?.companyId) {
            await dispatch(
               pendingVoucherDetails({
                  companyId: user?.loginhistory?.companyId,
                  accountId: parseInt(selected),
                  txnType: transactionType === 'payment' ? 1 : 0,
               }),
            );

            accountAmt = account.find((item) => item.id === selected)?.amt ?? null;
            setTotalPendingAccount(accountAmt);
         }
      } else {
         // Handle clearing the selection
         setFormData({
            ...formData,
            accountId: null,
            pendingVoucher: [],
            outAdjustments: [],
         });
         setTotalAmount(0);
         setTotalPendingAccount(0);
         dispatch({ type: 'CLEAR_VOUCHER_DETAILS' });
      }
   };

   useEffect(() => {
      if (selectedAccount) {
         handleAccountSelect(selectedAccount);
      }
   }, [selectedAccount]);

   useEffect(() => {
      const accIdRaw = searchParams.get('accId');
      if (accIdRaw) {
         handleAccountSelect(accIdRaw);
      }
   }, [selectedAccount]);

   // Initialize checked items and receivable amounts when pending vouchers load
   useEffect(() => {
      if (pendingVoucher.length > 0 && !formData.id) {
         // Initialize checked items as false for each voucher
         setCheckedItems(new Array(pendingVoucher.length).fill(false));

         // Also reset editing values
         setEditingValues({});

         // Calculate the total pending account
         const totalAmount = pendingVoucher.reduce((total, voucher) => {
            return total + parseFloat(voucher.osAmount);
         }, 0);

         // setTotalPendingAccount(totalAmount);
         dispatch(getAccount({ compId: user?.loginhistory?.companyId, status: true }));
         dispatch(getGLGroupsAllDropdown());
      }
   }, [pendingVoucher]);
   useEffect(() => {
      if (daybookTypeData?.length === 1) {
         setFormData((prev) => ({
            ...prev,
            daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : null, // Automatically select the only available option
         }));
      }
   }, [daybookTypeData]);

   // const companyId = localStorage.getItem('companyId') || '';

   const [totalAmount, setTotalAmount] = useState(0);
   const [isEditingAmount, setIsEditingAmount] = useState(false);
   const [tempReceivedAmount, setTempReceivedAmount] = useState(0);

   const [isEditing, setIsEditing] = useState(false);
   // const [editingValues, setEditingValues] = useState({});

   const handleEditValueChange = (index, newValue) => {
      // Allow empty string input
      if (newValue === '') {
         setEditingValues((prev) => ({
            ...prev,
            [index]: '', // Set to empty string instead of 0
         }));
         return;
      }

      // Convert from "₹ 100" format to numeric value
      const numericValue = parseFloat(newValue.replace(/[^\d.]/g, ''));
      const entry = pendingVoucher[index];

      // Handle NaN by setting a fallback value
      const validNumericValue = isNaN(numericValue) ? '' : numericValue;

      // Validate that the new value is valid and doesn't exceed the outstanding amount
      if (validNumericValue === '' || (validNumericValue >= 0 && validNumericValue <= parseFloat(entry.osAmount))) {
         setEditingValues((prev) => ({
            ...prev,
            [index]: validNumericValue,
         }));

         // Calculate total received amount from all editing values
         const updatedEditingValues = {
            ...editingValues,
            [index]: validNumericValue,
         };

         const totalReceivedAmount = Object.entries(updatedEditingValues).reduce(
            (sum, [_, value]) => sum + (parseFloat(value) || 0),
            0,
         );

         setReceivedAmount(totalReceivedAmount);
      }
   };

   const handleEditSubmit = (index) => {
      // Close the editor for this specific index
      setIsEditing((prev) => ({
         ...prev,
         [index]: false,
      }));

      // Ensure `editingValues[index]` is empty if user cleared it
      if (editingValues[index] === '') {
         setEditingValues((prev) => {
            const updatedValues = { ...prev };
            delete updatedValues[index]; // Remove key if empty
            return updatedValues;
         });
      }
   };

   // Add new effect to watch for daybookId changes
   useEffect(() => {
      // if (formData.daybookId && transactionType) {
      if (!formData.id && formData.daybookId && transactionType && user?.loginhistory?.companyId && isOpen) {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         function formatDate(dateStr) {
            const [day, month, year] = dateStr.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
         }

         dispatch(
            lastVoucherDetails({
               companyId: user?.loginhistory?.companyId,
               daybookId: Number(formData.daybookId),
               txnType: transactionType === 'payment' ? 1 : 0,
               type: isBankPage ? 14 : 13,
               fromDate: formatDate(fromDate),
               toDate: formatDate(toDate),
            }),
         );
      }
   }, [formData.daybookId, dispatch, user, transactionType, isOpen, formData.id]);

   useEffect(() => {
      if (lastVoucherData && lastVoucherData.docNumber && formData.daybookId) {
         // setLocalDocNumber(parseInt(lastVoucherData.docNumber) + 1);
         setFormData((prev) => ({
            ...prev,
            docNumber: parseInt(lastVoucherData.docNumber) + 1, // Automatically select the only available option
         }));
      } else {
         // If no lastVoucherData available, default to 1
         setLocalDocNumber(1);
         setFormData((prev) => ({
            ...prev,
            docNumber: 1, // Automatically select the only available option
         }));
      }
   }, [lastVoucherData, formData.daybookId]);

   useEffect(() => {
      // Only add the event listener when the modal is open
      if (!isOpen) return;

      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            handleFormSubmit();
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [isOpen, formData, isTransaction, checkedItems, receivedAmount, editingValues]);

   // Handle user typing in the amount field
   const handleDynamicCheckboxChange = useCallback(
      (index, checked) => {
         if (isEditingAmount) return; // Don't update amounts if user is actively editing the amount field

         setCheckedItems((prevCheckedItems) => {
            const newCheckedItems = [...prevCheckedItems];
            const currentEntry = pendingVoucher[index];

            // Check if we're in an intermediate state (partial payment)
            const isIntermediate =
               newCheckedItems[index] &&
               editingValues[index] !== undefined &&
               editingValues[index] < parseFloat(currentEntry.osAmount);

            if (isIntermediate) {
               if (!checked) {
                  // If unchecking from intermediate state, remove the checkbox completely
                  newCheckedItems[index] = false;

                  // Also remove the custom editing value for this entry
                  setEditingValues((prev) => {
                     const newValues = { ...prev };
                     delete newValues[index];
                     return newValues;
                  });
               } else {
                  // If checking again while in intermediate state, use full amount
                  newCheckedItems[index] = true;

                  // Remove the custom editing value to use full amount
                  setEditingValues((prev) => {
                     const newValues = { ...prev };
                     delete newValues[index];
                     return newValues;
                  });
               }
            } else {
               // Regular checkbox behavior
               newCheckedItems[index] = checked;

               // If unchecking, also remove any custom amounts
               if (!checked) {
                  setEditingValues((prev) => {
                     const newValues = { ...prev };
                     delete newValues[index];
                     return newValues;
                  });
               }
            }

            // Calculate the new total based on updated checked items
            const totalAmount = pendingVoucher.reduce((sum, voucher, idx) => {
               if (newCheckedItems[idx]) {
                  // If this item has a custom value (partial payment), use that value
                  const newEditingValues = { ...editingValues };
                  if (idx === index && isIntermediate && checked) {
                     // For the index we just changed from intermediate to full, use full amount
                     return sum + parseFloat(voucher.osAmount);
                  } else if (newEditingValues[idx] !== undefined) {
                     return sum + newEditingValues[idx];
                  } else {
                     // Otherwise use the full outstanding amount
                     return sum + parseFloat(voucher.osAmount);
                  }
               }
               return sum;
            }, 0);

            // Update received amount
            setReceivedAmount(totalAmount);
            setTempReceivedAmount(totalAmount);

            return newCheckedItems;
         });
      },
      [pendingVoucher, isEditingAmount, editingValues],
   );

   const handleReceivedAmountChange = (e) => {
      // Check if the value is empty (which happens after backspace)
      if (e.target.value === '') {
         setTempReceivedAmount(0);
         return;
      }

      // Use the raw value from the input
      const value = parseFloat(e.target.value);
      // const value = e.target.value;
      if (!isNaN(value)) {
         setTempReceivedAmount(value);
      }
   };

   // Handle when user completes entering an amount (Enter/Tab/blur)
   const handleReceivedAmountComplete = () => {
      setIsEditingAmount(false);

      const newAmount = tempReceivedAmount;
      setReceivedAmount(newAmount);

      // Initialize variables to track allocation
      let remainingToAllocate = newAmount;
      const newCheckedItems = new Array(pendingVoucher.length).fill(false);
      const newEditingValues = {};

      // Auto-allocate the amount starting from the first transaction
      for (let i = 0; i < pendingVoucher.length; i++) {
         const voucher = pendingVoucher[i];
         const voucherAmount = parseFloat(voucher.osAmount);

         if (remainingToAllocate <= 0) {
            // No more amount to allocate
            break;
         }

         if (remainingToAllocate >= voucherAmount) {
            // Full payment for this voucher - mark it as checked but don't set a custom value
            // (since it's fully paid, we don't need to show remaining)
            newCheckedItems[i] = true;
            delete newEditingValues[i]; // Remove any custom value if exists
            remainingToAllocate -= voucherAmount;
         } else {
            // Partial payment for this voucher - mark it as checked and set the partial amount
            newCheckedItems[i] = true;
            newEditingValues[i] = remainingToAllocate;
            remainingToAllocate = 0;
         }
      }

      // Update checked items and editing values
      setCheckedItems(newCheckedItems);
      setEditingValues(newEditingValues);
   };

   // Modified Select All checkbox handler
   const handleSelectAll = (isChecked) => {
      setCheckedItems(new Array(pendingVoucher.length).fill(isChecked));

      // Calculate the new total
      const newTotal = isChecked
         ? pendingVoucher.reduce((sum, voucher, idx) => {
            // If this item has a custom value (partial payment), use that value
            if (editingValues[idx] !== undefined) {
               return sum + editingValues[idx];
            } else {
               // Otherwise use the full outstanding amount
               return sum + parseFloat(voucher.osAmount);
            }
         }, 0)
         : 0;

      setReceivedAmount(newTotal);
      setTempReceivedAmount(newTotal); // Keep temp amount in sync
   };

   const checkLastDoc = async () => {
      // Prevent multiple calls
      if (isSubmitting) return;

      setIsSubmitting(true);

      try {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         function formatDate(dateStr) {
            const [day, month, year] = dateStr.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
         }

         const data = {
            companyId: user?.loginhistory?.companyId,
            daybookId: Number(formData.daybookId),
            docNumber: formData.docNumber.toString(),
            txnType: transactionType === 'payment' ? 1 : 0,
            type: isBankPage ? 14 : 13,
            fromDate: formatDate(fromDate),
            toDate: formatDate(toDate),
         };

         const res = await dispatch(checkLastDocNumberVoucher(data));

         if (res && res.code === 1 && res.data?.isError) {
            Swal.fire({
               title: res?.data?.message,
               showCancelButton: true,
               confirmButtonText: 'Yes',
               cancelButtonText: 'No',
               cancelButtonColor: '#d33',
               confirmButtonColor: '#3085d6',
            }).then(async (result) => {
               if (result.isConfirmed) {
                  const newFormData = { ...formData };
                  newFormData.docNumber = res.data?.newDocNo;
                  setFormData(newFormData);
                  await handleFormSubmit(newFormData);
               }
               setIsSubmitting(false); // Reset after SweetAlert
            });
         } else {
            await handleFormSubmit();
            setIsSubmitting(false);
         }
      } catch (error) {
         console.error('Error in checkLastDoc:', error);
         setIsSubmitting(false);
      }
   };

   const testData = async () => {
      try {
         const updatedFormData = {
            ...formData,
            amount: receivedAmount || formData.amount || 0,
         };
         await validationSchema.validate(updatedFormData, { abortEarly: false });
         setErrors({});
         if (parseFloat(updatedFormData.amount) === 0) {
            toast.error('Received Amount cannot be zero');
            return;
         }
         // ✅ proceed to submit
         checkLastDoc();
      } catch (err) {
         if (err.inner && err.inner.length > 0) {
            const validationErrors = {};
            err.inner.forEach((e) => {
               validationErrors[e.path] = e.message;
            });
            setErrors(validationErrors);

            // ⛔ Show the first error in a toast
            toast.error(err.inner[0].message);
         }
         return;
      }
   };

   const handleFormSubmit = async (newformData) => {
      const finalformData = newformData ? newformData : formData;
      if (!isTransaction) {
         const accountOnlyPayload = {
            companyId: parseInt(user?.loginhistory?.companyId),
            daybookId: parseInt(finalformData.daybookId) || null,
            // docNumber: (parseInt(lastVoucherData?.docNumber) + 1 || 1).toString(),
            // docNumber: localDocNumber.toString(),
            docNumber: finalformData.docNumber.toString(),
            txnType: parseInt(`${transactionType === 'payment' ? 1 : 0}`),
            txnDate: finalformData.txnDate || new Date().toISOString().split('T')[0],
            accountId: parseInt(finalformData.accountId),
            amount: parseInt(finalformData.amount) || receivedAmount,
            // Other essential fields only
            particulars: finalformData.particulars || '',
            notes1: finalformData.notes1 || '',
            userNote: finalformData.userNote || '',
            // You can add any other required fields here
         };

         // If in edit mode, include the ID
         if (isEditMode && currentRow) {
            accountOnlyPayload.id = currentRow.id;
         }
         const keysToDelete = [
            'id',
            'status',
            'createdu',
            'updatedu',
            'createdAt',
            'createdBy',
            'updatedAt',
            'updatedBy',
            'brokerName',
            'accountName',
            'daybookName',
            'supplierName',
            'bankName',
            'bankBranchName',
            'pendingVoucher',
         ];

         keysToDelete.forEach((key) => delete accountOnlyPayload[key]);
         // Call parent's handleSave with account-only data
         // handleSave(accountOnlyPayload);
         const res = await dispatch(addVoucher(accountOnlyPayload));
         dispatch(
            getBankVoucher({
               type: DAYBOOK_TYPE.BANK,
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit,
               companyId: user?.loginhistory?.companyId,
               search: searchQuery,
               sortBy: sorting.length ? sorting[0]?.id : 'id',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
            }),
         );
         if (res && res.code === 1) {
            if (user?.loginhistory?.companyId) {
               dispatch(
                  getDaybook({
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getDaybookForPayments({
                     type: isBankPageTrue ? DAYBOOK_TYPE.BANK : DAYBOOK_TYPE.CASH,
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getItem({
                     companyId: user?.loginhistory.companyId,
                     sortBy: 'name',
                     sortOrder: 'asc',
                     ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccount({
                     compId: Number(user?.loginhistory?.companyId),
                     accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccountForCashBank({
                     compId: Number(user?.loginhistory?.companyId),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
            }
         }
         handleClearData();
      } else {
         console.log("pendingVoucher", pendingVoucher, editingValues);
         const selectedTransactions = pendingVoucher
            .map((entry, index) => {
               if (!checkedItems[index]) return null;

               return {
                  drDocHeaderId: entry.salesId || 0,
                  drDaybookId: entry.salesDaybookId || null,
                  amount:
                     editingValues[index] !== undefined
                        ? editingValues[index]
                        : parseFloat(entry.osAmount),
                  notes: '',
               };
            })
            .filter(Boolean);

         // Create payload with all required fields
         const payload = {
            ...finalformData,
            companyId: parseInt(user?.loginhistory?.companyId),
            daybookId: parseInt(finalformData.daybookId) || null,
            docNumber: finalformData.docNumber.toString(),
            txnType: parseInt(`${transactionType === 'payment' ? 1 : 0}`),
            txnDate: finalformData.txnDate || new Date().toISOString().split('T')[0],
            accountId: parseInt(finalformData.accountId),
            amount: parseFloat(receivedAmount) || finalformData.amount,
            brokerId: finalformData.brokerId || 0,
            supplierId: finalformData.supplierId || 0,
            chequeNo: parseInt(finalformData.chequeNo) || null,
            chequeDate: finalformData.chequeDate || new Date().toISOString().split('T')[0],
            transactionNo: finalformData.transactionNo || null,
            bankId: parseInt(finalformData.bankId) || 0,
            bankBranchId: finalformData.bankBranchId || 0,
            particulars: finalformData.particulars || '',
            depositeDate: finalformData.depositeDate || null,
            clearingDate: finalformData.clearingDate || null,
            outAdjustments: selectedTransactions || [],
            tdsApplicable: finalformData.tdsApplicable || false,
            tdsAccountId: finalformData.tdsAccountId || 0,
            tdsLimit: finalformData.tdsLimit || 0,
            tdsRate: finalformData.tdsRate || 0,
            tdsCess: finalformData.tdsCess || 0,
            tdsSurcharge: finalformData.tdsSurcharge || 0,
            tdsAmount: finalformData.tdsAmount || 0,
            tdsCessAmount: finalformData.tdsCessAmount || 0,
            tdsSurchargeAmount: finalformData.tdsSurchargeAmount || 0,
            tdsHCessAmount: finalformData.tdsHCessAmount || 0,
            tdsInterestAmount: finalformData.tdsInterestAmount || 0,
            tdsPenaltyAmount: finalformData.tdsPenaltyAmount || 0,
            tdsOthersAmount: finalformData.tdsOthersAmount || 0,
            notes1: finalformData.notes1 || '',
            userNote: finalformData.userNote || '',

            taxableValue: finalformData.taxableValue || '',
            GSTAmount: finalformData.GSTAmount || 0,
            stateOfSupply: finalformData.stateOfSupply || 0,
            isRCM: finalformData.isRCM || false,
            GSTSubTxnType: finalformData.GSTSubTxnType || 0,
            HSNSACId: finalformData.HSNSACId || 0,
            typeofSupply: finalformData.typeofSupply || 0,
            partyBillNo: finalformData.partyBillNo || 0,
            GSTTxnType: finalformData.GSTTxnType || 0,
         };

         if (isEditMode && currentRow) {
            payload.id = currentRow.id;
         }
         delete payload.pendingVoucher;
         const res = await dispatch(addVoucher(payload));
         console.log("txnDate", finalformData.txnDate);
         if (res && res.code === 1) {
            if (user?.loginhistory?.companyId) {
               dispatch(
                  getDaybook({
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getDaybookForPayments({
                     type: isBankPageTrue ? DAYBOOK_TYPE.BANK : DAYBOOK_TYPE.CASH,
                     companyId: Number(user?.loginhistory?.companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getItem({
                     companyId: user?.loginhistory.companyId,
                     sortBy: 'name',
                     sortOrder: 'asc',
                     ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccount({
                     compId: Number(user?.loginhistory?.companyId),
                     accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               dispatch(
                  getAccountForCashBank({
                     compId: Number(user?.loginhistory?.companyId),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                  }),
               );
               fetchBankVoucherData && fetchBankVoucherData();
            }
         }
         handleClearData();
      }

      // Close the modal
      onClose();
      setCheckedItems([]); // Uncheck all transactions
      setReceivedAmount(0); // Reset received amount
      setEditingValues({});
      setTempReceivedAmount(0);
      setTotalPendingAccount(0);
      // Refresh the data
      // Reset form data
      handleClearData();
   };

   const docNumberRef = useRef(null);
   const [isDocNumberFocused, setIsDocNumberFocused] = useState(false);

   const PopoverContentWithClose = () => {
      const { onClose } = usePopoverContext();

      return (
         <PopoverContent>
            <PopoverBody>
               <Grid color={textColor} fontSize="25px" fontWeight="500">
                  <label>Discount / Surcharge</label>
               </Grid>
               <Grid display="flex" alignItems="center" gap={3} marginTop="20px">
                  <Grid>
                     <label>Type</label>
                  </Grid>
                  <Grid>
                     <Tooltip
                        label={
                           <>
                              <p>
                                 <strong>Discount</strong>
                                 <br />
                                 When you receive less than the Total Receivable from the Contact, and the remaining
                                 amount has been forgiven. So, the Contact doesn't need to pay the remaining amount.
                              </p>
                              <br />

                              <p>
                                 <strong>Surcharge</strong>
                                 <br />
                                 Opposite of the Discount. You receive more than the Total Receivable and You don't need
                                 to pay the extra received amount back to the Contact.
                              </p>
                              <br />

                              <p>
                                 <strong>Extra Receipt</strong>
                                 <br />
                                 You are receiving more than the Total Receivable. But, the extra received amount will
                                 remain open on the Contact's Statement. It will be adjusted against the future
                                 transactions like Sale.
                              </p>
                              <br />
                           </>
                        }
                        placement="left">
                        <img src={about} alt="about" width="18px" height="18px" />
                     </Tooltip>
                  </Grid>
                  <Grid>
                     <label>:</label>
                  </Grid>
                  <Grid width="220px">
                     <Menu placement="top">
                        <MenuButton
                           as={Button}
                           rightIcon={<ChevronDownIcon />}
                           border="1px solid"
                           color={textColor}
                           borderRadius="10px">
                           {selectedOption}
                        </MenuButton>
                        <MenuList color={textColor}>
                           <MenuItem onClick={() => handleSelect('None')}>None</MenuItem>
                           <MenuItem onClick={() => handleSelect('Discount (-)')}>Discount (-)</MenuItem>
                           <MenuItem onClick={() => handleSelect('Extra Receipt (+)')}>Extra Receipt (+)</MenuItem>
                           <MenuItem onClick={() => handleSelect('Surcharge (+)')}>Surcharge (+)</MenuItem>
                        </MenuList>
                     </Menu>
                  </Grid>
               </Grid>
               <Grid display="flex" alignItems="center" marginTop="20px">
                  <Grid marginRight={5}>
                     <label>Amount</label>
                  </Grid>
                  <Grid marginRight={3}>
                     <label>:</label>
                  </Grid>

                  <Grid width="220px">
                     {/* Input Field */}
                     <Input
                        // value={`${inputValues}`}
                        onChange={handleInputChange}
                        placeholder="₹ Enter value"
                        border="1px solid" // Remove border for clean look
                        paddingRight="30px" // Space for ₹ symbol
                        isDisabled={selectedOption === 'None'}
                        color={textColor}
                        bg={useColorModeValue('gray.100', '#2d3748')}
                     />
                  </Grid>
               </Grid>
               <Grid display="Flex">
                  <Button colorScheme="blue" size="sm" width="45%" mt={5} onClick={onClose}>
                     Cancel
                  </Button>
                  <Button colorScheme="blue" size="sm" width="45%" mt={5} ml={7} onClick={onClose}>
                     Apply
                  </Button>
               </Grid>
            </PopoverBody>
         </PopoverContent>
      );
   };

   useEffect(() => {
      setTimeout(() => {
         txnDateRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter') {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      } else if (e.key === 'Tab') {
         e.preventDefault();
         if (e.shiftKey) {
            preRef?.current?.focus();
         } else {
            nextRef?.current?.focus();
         }
      }
   };
   // const accountData = useSelector((state) => state?.account?.list);
   const targetGlGroup = glGroup?.find((group) => group.code === 'K');

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== txnDateRef.current) {
               // Focus txnDateRef if not already focused
               txnDateRef.current?.focus();
            } else {
               // If already focused, go back
               onClose();
            }
            e.stopPropagation();
            e.preventDefault();
         }
      };

      window.addEventListener('keydown', handleKeyDown, true);
      return () => {
         window.removeEventListener('keydown', handleKeyDown, true);
      };
   }, []);

   // useEffect(() => {
   //    if (isOpen) {
   //       dispatch(
   //          lastVoucherDetails({
   //             companyId: companyId,
   //             txnType: transactionType === 'payment' ? 1 : 0,
   //             type: isBankPage ? 14 : 13,
   //          }),
   //       );
   //    }
   // }, [isOpen]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} closeOnEsc={false} size="4xl">
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={5}
            boxShadow="lg"
            style={{ zIndex: 10511111 }}>
            <ModalHeader fontSize="24px" fontWeight="600" mb={4}>
               <Grid templateColumns="repeat(5, 1fr)" gap={4}>
                  <GridItem colSpan={2}>
                     {isEditMode
                        ? 'Edit Journal Voucher'
                        : `New ${isBankPage ? 'Bank' : 'Cash'} ${transactionType === 'receive' ? 'Receive' : 'Payment'
                        }`}{' '}
                     {/* {lastVoucherData?.docNumber ? `#${parseInt(lastVoucherData?.docNumber) + 1}` : '1'} */}
                     {formData.docNumber || 1}
                     {/* {localDocNumber.toString()} */}
                  </GridItem>
                  <GridItem>
                     <Checkbox isChecked={isTransaction} onChange={() => setIsTransaction(!isTransaction)}>
                        Transactions
                     </Checkbox>
                  </GridItem>
                  <Text
                     as="span"
                     fontSize="sm"
                     fontWeight="normal"
                     ml={2}
                     color={daybookbalance > 0 ? 'green.500' : 'red.500'}>
                     {typeof daybookbalance === 'number'
                        ? (() => {
                           const amount = Math.abs(daybookbalance).toFixed(2);
                           const [whole, decimal] = amount.split('.');

                           return (
                              <>
                                 Balance: ₹{whole}.
                                 <Text as="span" fontSize="xs" verticalAlign="baseline">
                                    {decimal}
                                 </Text>{' '}
                                 {daybookbalance > 0 ? 'DB' : 'CR'}
                              </>
                           );
                        })()
                        : 'Balance: Nil'}
                  </Text>
               </Grid>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <Grid templateColumns="repeat(2, 1fr)" gap={6}>
                  <Grid>
                     <GridItem>
                        <InputField
                           name="txnDate"
                           label="DATE"
                           ref={txnDateRef}
                           type="date"
                           value={formData.txnDate}
                           onChange={(e) => setFormData({ ...formData, txnDate: e.target.value })}
                           errorName="txnDate" // Add this if you have validation errors for this field
                           errors={errors}
                           required={false} // Set to true if this field is required
                           bg={useColorModeValue('gray.100', '#2d3748')}
                           borderRadius="12px"
                           fontSize="18px"
                           height="50px"
                           px="20px"
                           onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                 e.preventDefault();
                                 docNumberRef.current?.focus();
                              } else if (e.key === 'Tab') {
                                 e.preventDefault();
                                 if (e.shiftKey) {
                                 } else {
                                    docNumberRef.current?.focus();
                                 }
                              }
                           }}
                           color={textColor}
                           onFocus={() => handleFocus('date')}
                           onBlur={handleBlur}
                        />
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <FormControl>
                           {renderDynamicDropdown(
                              'daybookId',
                              'Daybook',
                              daybookTypeData || [],
                              {
                                 errorName: 'header.daybookId',
                                 value: formData.daybookId || '',
                                 onChange: (value) => {
                                    setFormData({
                                       ...formData,
                                       daybookId: value, // Update the daybookId in formData
                                    });
                                 },
                                 focusBorderColor: 'blue.500',
                                 _focus: {
                                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                 },
                                 ref: daybookRef,
                                 nextRef: accountRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'daybook',
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                       accountRef.current?.focus();
                                       e.preventDefault();
                                    } else if (e.key === 'Tab') {
                                       e.preventDefault();
                                       if (e.shiftKey) {
                                          docNumberRef.current?.focus();
                                       } else {
                                          accountRef.current?.focus();
                                       }
                                    }
                                 },
                              },
                              errors,
                              textColor,
                              true,
                              isBankPage ? 'Select Bank Account' : 'Select Cash Account',
                           )}
                        </FormControl>
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <AccountSelect
                           ref={accountRef}
                           name="accountId"
                           options={filteredAccountData}
                           label="Account"
                           value={selectedAccount?.id ? selectedAccount?.id : selectedAccount}
                           errors={{}}
                           errorName=""
                           isClearable
                           isSearchable
                           onChange={(value) => {
                              // handleAccount('accountId', value);
                              setSelectedAccount(value);
                              handleAccountSelect(value);
                           }}
                           onKeyDown={(e) => handleKeyDown(e, receivedAmtRef, daybookRef)}
                           showCustomNoOptions={true}
                           openfrom="salesdaybook"
                           glGroup={targetGlGroup}
                        // errors={errors}
                        />
                     </GridItem>
                  </Grid>
                  <Grid>
                     <FormControl>
                        <div
                           style={{
                              position: 'relative',
                              height: '50px',
                              marginTop: '5px',
                           }}>
                           <InputField
                              ref={docNumberRef}
                              name="docNumber"
                              label="Doc Number"
                              type="number"
                              placeholder="Doc Number"
                              value={formData.docNumber || ''}
                              // value={localDocNumber || formData.docNumber || singleVoucher?.docNumber || ''}
                              onChange={(e) => setFormData({ ...formData, docNumber: e.target.value })}
                              onFocus={() => {
                                 setIsDocNumberFocused(true);
                              }}
                              onBlur={() => {
                                 setIsDocNumberFocused(false);
                              }}
                              onKeyDown={(e) => {
                                 if (e.key === 'Enter') {
                                    e.preventDefault();
                                    daybookRef.current?.focus();
                                 } else if (e.key === 'Tab') {
                                    e.preventDefault();
                                    if (e.shiftKey) {
                                       txnDateRef.current?.focus();
                                    } else {
                                       daybookRef.current?.focus();
                                    }
                                 } else if (e.key === 'PageDown' || e.keyCode === 34) {
                                    handelformchange(lastVoucherData);
                                 }
                              }}
                              color={textColor}
                              bg={useColorModeValue('gray.100', '#2d3748')}
                              borderRadius="12px"
                              fontSize="18px"
                              height="50px"
                              px="20px"
                           />
                        </div>
                     </FormControl>
                     <GridItem paddingTop="20px">
                        <FormControl>
                           <div
                              style={{
                                 position: 'relative',
                                 height: '50px',
                                 marginTop: '5px',
                              }}>
                              <Input
                                 id="amount1"
                                 type="text"
                                 placeholder="Amount"
                                 // value={selectedAccount?.amt}
                                 value={totalPendingAccount}
                                 // value={formData?.pendingAmt || totalPendingAccount}
                                 readOnly
                                 color={textColor}
                                 bg={useColorModeValue('gray.100', '#2d3748')}
                                 borderRadius="12px"
                                 fontSize="18px"
                                 height="50px"
                                 px="20px"
                              />
                           </div>
                        </FormControl>
                     </GridItem>
                     <GridItem paddingTop="20px">
                        <FormControl>
                           <div
                              style={{
                                 position: 'relative',
                                 height: '50px',
                                 marginTop: '5px',
                              }}>
                              <Input
                                 id="receivedAmount"
                                 type="number"
                                 placeholder={transactionType === 'payment' ? 'Payment Amount' : 'Received Amount'}
                                 name="amount"
                                 ref={receivedAmtRef}
                                 // value={formData.amount || ''}
                                 value={
                                    isEditingAmount
                                       ? tempReceivedAmount === 0
                                          ? ''
                                          : tempReceivedAmount
                                       : receivedAmount === 0
                                          ? ''
                                          : receivedAmount
                                 }
                                 onFocus={() => {
                                    setIsEditingAmount(true);
                                    setTempReceivedAmount(receivedAmount);
                                 }}
                                 // onChange={handleReceivedAmountChange}
                                 onChange={(e) => {
                                    // Update tempReceivedAmount for display
                                    handleReceivedAmountChange(e);

                                    // Also update formData.amount
                                    setFormData((prevFormData) => ({
                                       ...prevFormData,
                                       amount: e.target.value === '' ? 0 : parseInt(e.target.value),
                                    }));
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       if (isBankPage) {
                                          chequeNoRef.current?.focus();
                                       } else {
                                          notesRef.current?.focus();
                                       }
                                    } else if (e.key === 'Tab') {
                                       e.preventDefault();
                                       if (e.shiftKey) {
                                          accountRef.current?.focus();
                                       } else {
                                          if (isBankPage) {
                                             chequeNoRef.current?.focus();
                                          } else {
                                             notesRef.current?.focus();
                                          }
                                       }
                                    }
                                 }}
                                 onDragLeave={(e) => {
                                    handleReceivedAmountComplete(e);
                                 }}
                                 // onBlur={handleReceivedAmountComplete}
                                 onBlur={(e) => {
                                    handleReceivedAmountComplete();

                                    // Ensure formData.amount is updated with final value
                                    setFormData((prevFormData) => ({
                                       ...prevFormData,
                                       amount: receivedAmount,
                                    }));
                                 }}
                                 onWheel={(e) => e.target.blur()}
                                 readOnly={false} // Allow the user to edit the value
                                 color={textColor}
                                 bg={useColorModeValue('gray.100', '#2d3748')}
                                 borderRadius="12px"
                                 fontSize="18px"
                                 height="50px"
                                 px="20px"
                              />
                              <label
                                 htmlFor="receivedAmount"
                                 style={{
                                    position: 'absolute',
                                    top: totalAmount ? '-10px' : '15px',
                                    left: '15px',
                                    transform: totalAmount ? 'translateX(10px) scale(0.75)' : 'translateX(0) scale(1)',
                                    color: 'black',
                                    transition: 'transform 200ms, color 200ms',
                                    pointerEvents: 'none',
                                    height: '25px',
                                    width: 'auto',
                                    borderRadius: '2vh',
                                    display: 'inline-block',
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                 }}></label>
                           </div>
                        </FormControl>
                     </GridItem>
                  </Grid>
                  {isBankPage ? (
                     <>
                        <GridItem paddingTop="0px">
                           <FormControl>
                              <div
                                 style={{
                                    position: 'relative',
                                    height: '50px',
                                    marginTop: '5px',
                                 }}>
                                 <Input
                                    ref={chequeNoRef}
                                    id="chequeNo"
                                    type="text"
                                    placeholder="Enter Cheque Number"
                                    name="chequeNo"
                                    value={formData.chequeNo || ''}
                                    onChange={(e) => setFormData({ ...formData, chequeNo: e.target.value })}
                                    color={textColor}
                                    // bg={useColorModeValue('gray.100', '#2d3748')}
                                    borderRadius="12px"
                                    _placeholder={{ color: 'transparent' }}
                                    fontSize="18px"
                                    height="50px"
                                    px="20px"
                                    onFocus={() => handleFocus('chequeNo')}
                                    onBlur={handleBlur}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          chequeDateRef.current?.focus();
                                       } else if (e.key === 'Tab') {
                                          e.preventDefault();
                                          if (e.shiftKey) {
                                             receivedAmtRef.current?.focus();
                                          } else {
                                             chequeDateRef.current?.focus();
                                          }
                                       }
                                    }}
                                 />
                                 <label
                                    htmlFor="chequeNo"
                                    style={{
                                       position: 'absolute',
                                       top: '-10px',
                                       left: '15px',
                                       transform: 'translateX(10px) scale(0.75)',
                                       color: textColor,
                                       transition: 'transform 200ms, color 200ms',
                                       pointerEvents: 'none',
                                       height: '25px',
                                       width: 'auto',
                                       // backgroundColor: useColorModeValue('white', '#2d3748'),
                                       borderRadius: '2vh',
                                       display: 'inline-block',
                                       paddingLeft: 10,
                                       paddingRight: 10,
                                    }}>
                                    CHEQUE NUMBER
                                 </label>
                              </div>
                           </FormControl>
                        </GridItem>

                        <GridItem paddingTop="0px">
                           <FormControl>
                              <div
                                 style={{
                                    position: 'relative',
                                    height: '50px',
                                    marginTop: '5px',
                                 }}>
                                 <Input
                                    ref={chequeDateRef}
                                    id="chequeDate"
                                    type="date"
                                    placeholder="Enter Cheque Date"
                                    name="chequeDate"
                                    value={formData.chequeDate || ''}
                                    onChange={(e) => setFormData({ ...formData, chequeDate: e.target.value })}
                                    color={textColor}
                                    // bg={useColorModeValue('gray.100', '#2d3748')}
                                    borderRadius="12px"
                                    _placeholder={{ color: 'transparent' }}
                                    fontSize="18px"
                                    height="50px"
                                    px="20px"
                                    onFocus={() => handleFocus('chequeDate')}
                                    onBlur={handleBlur}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          notesRef.current?.focus();
                                       } else if (e.key === 'Tab') {
                                          e.preventDefault();
                                          if (e.shiftKey) {
                                             chequeNoRef.current?.focus();
                                          } else {
                                             notesRef.current?.focus();
                                          }
                                       }
                                    }}
                                 />
                                 <label
                                    htmlFor="chequeDate"
                                    style={{
                                       position: 'absolute',
                                       top: '-10px',
                                       left: '15px',
                                       transform: 'translateX(10px) scale(0.75)',
                                       color: textColor,
                                       transition: 'transform 200ms, color 200ms',
                                       pointerEvents: 'none',
                                       zIndex: 100,
                                       height: '25px',
                                       width: 'auto',
                                       // backgroundColor: useColorModeValue('white', '#2d3748'),
                                       borderRadius: '2vh',
                                       display: 'inline-block',
                                       paddingLeft: 10,
                                       paddingRight: 10,
                                    }}>
                                    CHEQUE DATE
                                 </label>
                              </div>
                           </FormControl>
                        </GridItem>
                     </>
                  ) : null}
               </Grid>
               {isTransaction && (
                  <Grid>
                     Transactions
                     <Grid border="2px solid" color="gray.200" borderRadius="10px">
                        <Grid display="flex" padding="10px 0px 10px 0px">
                           <Grid width="10%" justifyContent="center">
                              {pendingVoucher.length > 0 && (
                                 <Checkbox
                                    isChecked={checkedItems.length > 0 && checkedItems.every(Boolean)}
                                    isIndeterminate={
                                       checkedItems.some(Boolean) &&
                                       (!checkedItems.every(Boolean) ||
                                          pendingVoucher.some(
                                             (voucher, idx) =>
                                                checkedItems[idx] &&
                                                editingValues[idx] !== undefined &&
                                                editingValues[idx] < parseFloat(voucher.osAmount),
                                          ))
                                    }
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                 />
                              )}
                           </Grid>
                           <Grid width="26%" color={textColor}>
                              <label>Description</label>
                           </Grid>
                           {/* <Grid width="15%" color="blackAlpha.900">
                    <label>Due Date</label>
                  </Grid> */}
                           <Grid width="15%" color={textColor}>
                              <label>Net Amount</label>
                           </Grid>
                           <Grid width="27%" color={textColor}>
                              <label>Pending Amount</label>
                           </Grid>
                           <Grid width="auto" color={textColor}>
                              <label>{transactionType === 'payment' ? 'Payment' : 'Receive'}</label>
                           </Grid>
                        </Grid>

                        {pendingVoucher.length > 0 &&
                           pendingVoucher.map((entry, index) => {
                              const today = new Date();
                              const transactionDate = new Date(entry.transactionAt);
                              const timeDifference = today - transactionDate;
                              const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
                              const day = String(transactionDate.getDate()).padStart(2, '0');
                              const month = String(transactionDate.getMonth() + 1).padStart(2, '0');
                              const year = transactionDate.getFullYear();
                              const formattedTransactionDate = `${day}/${month}/${year}`;

                              return (
                                 <Grid
                                    display="flex"
                                    borderTop="1px solid"
                                    padding="10px 0px 10px 0px"
                                    alignItems="center"
                                    id={`grid-${index}`}
                                    key={`voucher-${index}`}>
                                    <Grid width="10%" justifyContent="center">
                                       <Checkbox
                                          id={`checkbox-${index}`}
                                          isChecked={checkedItems[index] || false}
                                          isIndeterminate={
                                             checkedItems[index] &&
                                             editingValues[index] !== undefined &&
                                             editingValues[index] < parseFloat(entry.osAmount)
                                          }
                                          onChange={(e) => {
                                             handleDynamicCheckboxChange(index, e.target.checked);
                                          }}
                                       />
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="26%">
                                       <Grid fontSize="15px" color="black">
                                          <label>
                                             {transactionType === 'payment' ? `Purchase#${entry.docno}` : 'Sale#'}
                                             {entry.docno}
                                          </label>
                                       </Grid>
                                       <Grid fontSize="10px" display="flex">
                                          <Grid>
                                             <label>{formattedTransactionDate}</label>
                                          </Grid>
                                          <Grid paddingLeft="10px">
                                             <label>( Days {daysDifference})</label>
                                          </Grid>
                                       </Grid>
                                    </Grid>
                                    {/* <Grid color="blackAlpha.700" width="15%">
                          <label>-</label>
                        </Grid> */}
                                    <Grid color="blackAlpha.700" width="15%">
                                       <label>₹{entry?.netAmount}</label>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="27%" display="flex" alignItems="center">
                                       <label>₹{entry?.osAmount}</label>
                                       <Grid
                                          border="2px solid"
                                          color={transactionType === 'payment' ? 'orange' : 'green.600'}
                                          borderColor={transactionType === 'payment' ? 'orange' : 'green.600'}
                                          borderRadius="7px"
                                          padding="2px 7px"
                                          marginLeft="10px">
                                          {transactionType === 'payment' ? 'Payable' : 'Receivable'}
                                       </Grid>
                                    </Grid>
                                    <Grid color="blackAlpha.700" width="22%" display="flex">
                                       <Grid width="80%">
                                          <Grid>
                                             {isEditing[index] ? (
                                                <Input
                                                   autoFocus
                                                   value={
                                                      editingValues[index] !== undefined
                                                         ? `₹ ${editingValues[index]}`
                                                         : ''
                                                   }
                                                   // onChange={(e) => handleEditValueChange(index, e.target.value)}
                                                   onChange={(e) => {
                                                      handleEditValueChange(index, e.target.value);

                                                      // Dynamically update checkbox state based on edited value
                                                      const inputValue = parseFloat(
                                                         e.target.value.replace(/[^\d.]/g, ''),
                                                      );
                                                      const netAmount = parseFloat(entry.osAmount);

                                                      setCheckedItems((prevCheckedItems) => {
                                                         const newCheckedItems = [...prevCheckedItems];

                                                         if (inputValue === netAmount) {
                                                            // Full checkbox if edited value matches net amount
                                                            newCheckedItems[index] = true;
                                                         } else if (inputValue > 0 && inputValue < netAmount) {
                                                            // Partial/indeterminate checkbox if value is less than net amount
                                                            newCheckedItems[index] = true;
                                                         } else if (inputValue === 0) {
                                                            // Unchecked if value is zero
                                                            newCheckedItems[index] = false;
                                                         }

                                                         return newCheckedItems;
                                                      });
                                                   }}
                                                   onBlur={() => handleEditSubmit(index)}
                                                   onKeyDown={(e) => e.key === 'Enter' && handleEditSubmit(index)}
                                                   size="sm"
                                                />
                                             ) : (
                                                <label>
                                                   {editingValues[index] !== undefined
                                                      ? `₹ ${editingValues[index]}`
                                                      : checkedItems[index]
                                                         ? `₹ ${entry.osAmount}`
                                                         : '₹ 0'}
                                                </label>
                                             )}
                                          </Grid>
                                          {editingValues[index] !== undefined &&
                                             editingValues[index] < parseFloat(entry.osAmount) && (
                                                <label style={{ color: 'orange', fontSize: '14px' }}>
                                                   Remaining: ₹{' '}
                                                   {(parseFloat(entry.osAmount) - editingValues[index]).toFixed(2)}
                                                </label>
                                             )}
                                       </Grid>

                                       <Grid width="20%">
                                          <img
                                             src={editIcon}
                                             alt="edit icon"
                                             width="20px"
                                             height="20px"
                                             style={{ cursor: 'pointer' }}
                                             onClick={() => {
                                                // Update only this specific entry's edit state using index
                                                setIsEditing((prev) => ({
                                                   ...prev,
                                                   [index]: true,
                                                }));

                                                // Initialize editing value for this specific index
                                                setEditingValues((prev) => ({
                                                   ...prev,
                                                   [index]:
                                                      editingValues[index] !== undefined
                                                         ? editingValues[index]
                                                         : checkedItems[index]
                                                            ? parseFloat(entry.osAmount)
                                                            : '',
                                                }));
                                             }}
                                          />
                                       </Grid>
                                    </Grid>
                                 </Grid>
                              );
                           })}
                     </Grid>
                  </Grid>
               )}
               <Grid display="flex" marginTop="20px" marginBottom="20px">
                  <Grid width="50%" backgroundColor={boxBgColor} borderRadius="10px">
                     <Grid display="flex" alignItems="center" padding="20px 20px 10px">
                        <Grid color={textColor}>Send Notification To Contact</Grid>
                        <Grid paddingLeft="10px">
                           <Tooltip
                              label="Contact will receive Email/Mobile notification when the Receipt is created."
                              placement="bottom">
                              <img src={about} alt="about" width="18px" height="18px" />
                           </Tooltip>
                        </Grid>
                        <Grid paddingLeft="80px">
                           <FormControl display="flex" alignItems="center">
                              <Switch id="notification" defaultChecked={true} />
                           </FormControl>
                        </Grid>
                     </Grid>
                     <Grid padding="10px 20px 20px" display="flex" alignItems="center">
                        <Grid color={textColor}>Print PDF of Receipt</Grid>
                        <Grid paddingLeft="170px">
                           <FormControl display="flex" alignItems="center">
                              <Switch id="pdf" />
                           </FormControl>
                        </Grid>
                     </Grid>
                  </Grid>
                  <Grid borderRadius="10px" width="45%" marginLeft="5%">
                     {/* <Grid paddingLeft="40%">
                <label>+ Add Discount / Surcharge</label>
              </Grid> */}
                     {selectedOption === 'None' ? (
                        <Grid width="auto" height="20px" paddingLeft="150px" id="grid1">
                           <Popover placement="bottom">
                              <PopoverTrigger>
                                 <label
                                    style={{
                                       cursor: 'pointer',
                                       // color: 'blue',
                                       textDecoration: 'underline',
                                    }}>
                                    + Add Discount / Surcharge
                                 </label>
                              </PopoverTrigger>
                              <PopoverContentWithClose />
                           </Popover>
                        </Grid>
                     ) : (
                        ''
                     )}
                     {(selectedOption === 'Discount (-)' ||
                        selectedOption === 'Surcharge (+)' ||
                        selectedOption === 'Extra Receipt (+)') && (
                           <Grid display="flex" ml={20} id="grid2">
                              <Grid>
                                 <Grid>Total</Grid>
                                 <Grid borderBottom="1px solid" paddingBottom="5px">
                                    {selectedOption}
                                 </Grid>
                                 <Grid paddingTop="5px">Net Amount</Grid>
                              </Grid>
                              <Grid>
                                 <Grid pl="60px" pr="50px">
                                    ₹ {totalAmount}
                                 </Grid>
                                 <Grid
                                    borderBottom="1px solid"
                                    paddingBottom="5px"
                                    pl="60px"
                                    display="flex"
                                    alignItems="center">
                                    <Grid>₹{/* {inputValues} */}</Grid>
                                    <Grid ml="15px">
                                       <Popover placement="bottom">
                                          <PopoverTrigger>
                                             {/* <label style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}>
                              + Add Discount / Surcharge
                            </label> */}
                                             <img src={editIcon2} alt="edit" width="18px"></img>
                                          </PopoverTrigger>
                                          <PopoverContentWithClose />
                                       </Popover>
                                    </Grid>
                                 </Grid>
                                 <Grid paddingTop="5px" pl="60px">
                                    {/* {selectedOption === 'Discount (-)'
                        ? `₹ ${Number(totalAmount) - Number(inputValues)}`
                        : `₹ ${Number(totalAmount) + Number(inputValues)}`} */}
                                 </Grid>
                              </Grid>
                           </Grid>
                        )}
                  </Grid>
               </Grid>
               {/* <GridItem colSpan={2}>
                  <FormControl>
                     <div
                        style={{
                           position: 'relative',
                           height: '50px',
                           marginTop: '5px',
                           marginBottom: 25,
                        }}>
                        <Textarea
                           id="notes"
                           placeholder="Enter Notes"
                           value={formData?.userNote || ''}
                           ref={notesRef}
                           onChange={(e) =>
                              setFormData({
                                 ...formData,
                                 userNote: e.target.value,
                              })
                           }
                           onKeyDown={(e) => {
                              if (e.key === 'Enter' && !e.shiftKey) {
                                 e.preventDefault();
                                 createRef.current?.focus();
                              } else if (e.key === 'Tab') {
                                 e.preventDefault();
                                 if (e.shiftKey) {
                                    if (isBankPage) {
                                       chequeDateRef.current?.focus();
                                    } else {
                                       receivedAmtRef.current?.focus();
                                    }
                                 } else {
                                    createRef.current?.focus();
                                 }
                              }
                           }}
                           // value={currentRow?.notes || ''}
                           // value={formData?.userNote || ''}
                           // onChange={(e) =>
                           //   setCurrentRow({ ...currentRow, notes: e.target.value })
                           // }
                           name="userNote"
                           color={textColor}
                           bg={useColorModeValue('gray.100', '#2d3748')}
                           borderRadius="12px"
                           _placeholder={{ color: 'transparent' }}
                           fontSize="18px"
                           height="50px"
                           px="20px"
                           onFocus={() => handleFocus('notes')}
                           onBlur={handleBlur}
                        />
                        <label
                           htmlFor="notes"
                           style={{
                              position: 'absolute',
                              top: focusedInput === 'notes' || (currentRow?.notes ? true : false) ? '-10px' : '15px',
                              left: '15px',
                              transform:
                                 focusedInput === 'notes' || (currentRow?.notes ? true : false)
                                    ? 'translateX(10px) scale(0.75)'
                                    : 'translateX(0) scale(1)',
                              color: textColor,
                              transition: 'transform 200ms, color 200ms',
                              pointerEvents: 'none',
                              zIndex: 100,
                              height: '25px',
                              width: 'auto',
                              backgroundColor: useColorModeValue('white', '#2d3748'),
                              borderRadius: '2vh',
                              display: 'inline-block',
                              paddingLeft: 10,
                              paddingRight: 10,
                           }}>
                           NOTES
                        </label>
                     </div>
                  </FormControl>
               </GridItem> */}
               <GridItem colSpan={2}>
                  <TextareaField
                     ref={notesRef}
                     name="userNote"
                     label="NOTES"
                     // placeholder="Enter Notes"
                     value={formData?.userNote || ''}
                     onChange={(e) =>
                        setFormData({
                           ...formData,
                           userNote: e.target.value,
                        })
                     }
                     onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                           e.preventDefault();
                           createRef.current?.focus();
                        } else if (e.key === 'Tab') {
                           e.preventDefault();
                           if (e.shiftKey) {
                              if (isBankPage) {
                                 chequeDateRef.current?.focus();
                              } else {
                                 receivedAmtRef.current?.focus();
                              }
                           } else {
                              createRef.current?.focus();
                           }
                        }
                     }}
                     fontSize="18px"
                     height="50px"
                     px="20px"
                  />
               </GridItem>
            </ModalBody>
            <ModalFooter>
               <Button
                  ref={createRef}
                  onClick={testData}
                  variant="darkBrand"
                  color="white"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="full"
                  px="24px"
                  py="5px"
                  _active={{ bg: '#06b' }}
                  mr={5}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        cancelRef.current?.focus();
                     }
                  }}>
                  Create
               </Button>
               <Button
                  ref={cancelRef}
                  variant="ghost"
                  onClick={onClose}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        createRef.current?.focus();
                     }
                  }}>
                  Cancel
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default PaymentcaseForm;
